import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import NavLinks from './NavLinks.js';
import Logo from './Logo.js';
import SimpleNavbar from './SimpleNavbar.js';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Get the hero section height (min-h-screen)
      const heroHeight = window.innerHeight;
      // Check if we've scrolled past the hero section
      setIsScrolled(window.scrollY > heroHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence mode="wait">
      {isScrolled ? (
        <SimpleNavbar key="simple" />
      ) : (
        <motion.header
          key="full"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur-sm shadow-sm w-full"
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 items-center justify-between">
              <Logo />
              <NavLinks />
            </div>
          </div>
        </motion.header>
      )}
    </AnimatePresence>
  );
};

export default Navbar; 